import React from "react";
import "@frameworks/web/stylesheets/components/header/nav/SupportDropdown.scss";
import SupportCall from "../../assets/images/headerDesk/support/SupportCall.png";
import SupportMail from "../../assets/images/headerDesk/support/SupportMail.svg";
import SupportGetStarted from "../../assets/images/headerDesk/support/SupportGetStarted.svg";
import SupportFAQ from "../../assets/images/headerDesk/support/SupportFAQ.svg";
import SupportLocation from "../../assets/images/headerDesk/support/SupportLocation.svg";
function SupportDropdown() {
    return (React.createElement("div", { className: "support-drop" },
        React.createElement("ul", null,
            React.createElement("li", null,
                React.createElement("div", { className: "contact-support" },
                    React.createElement("div", { className: "contact-support-call" },
                        React.createElement("img", { src: SupportCall, alt: "Call" }),
                        React.createElement("p", null,
                            "1800-102-3335 ",
                            React.createElement("br", null),
                            React.createElement("span", { className: "contact-support-call-timing" }, "(8:30 AM - 05:30 PM)"))),
                    React.createElement("div", { className: "contact-support-mail" },
                        React.createElement("img", { src: SupportMail, alt: "Mail" }),
                        React.createElement("p", null, " helpdesk@edelweiss.in")))),
            React.createElement("li", { className: "support-drop-menu-item" },
                React.createElement("img", { src: SupportGetStarted, alt: "Get Started" }),
                React.createElement("p", null, "Get Started")),
            React.createElement("div", { className: "support-drop-menu-item-underline" }),
            React.createElement("li", { className: "support-drop-menu-item" },
                React.createElement("img", { src: SupportFAQ, alt: "FAQs" }),
                React.createElement("p", null, "Visit FAQs")),
            React.createElement("div", { className: "support-drop-menu-item-underline" }),
            React.createElement("li", { id: "locate-us", className: "support-drop-menu-item" },
                React.createElement("img", { src: SupportLocation, alt: "Locate Us" }),
                React.createElement("p", null, "Locate Us")))));
}
export default SupportDropdown;
